import {Link} from "react-router-dom";
import Routing from "../../Routing.ts";
import Icon from "../selfcare/Icon.tsx";
import {formatAmount} from "../../util/formatter.ts";
import IconTrophy from "../icons/IconTrophy.tsx";
import IconGears from "../icons/IconGears.tsx";
import IconCalendarCheck from "../icons/IconCalendarCheck.tsx";
import IconSpeedometerHigh from "../icons/IconSpeedometerHigh.tsx";
import IconServiceStatus from "../icons/IconServiceStatus.tsx";
import IconPing from "../icons/IconPing.tsx";
import IconWifi from "../icons/IconWifi.tsx";

const mbb_price_default = 279;
const mbb_price = 199;
const mbb_time = 3;
const mbb_time_text = 'Første ' + mbb_time + ' mdr.';
const mbb_min_6 = (mbb_time * mbb_price) + (mbb_time * mbb_price_default);

const fiber_price_default = 299;
const fiber_price = 99;
const fiber_time = 6;
const fiber_time_text = 'Første ' + fiber_time + ' mdr.';
const fiber_min_6 = fiber_time * fiber_price;

export default function ProductShowcaseComponent() {
    return (
        <section className="products-wrapper">
            <ul className="products-showcase">
                <li className="product mbb">
                    <div className="image"></div>
                    <div className="product-box">
                        <div className="product-text">
                            <h3 className="heading heading--montserrat heading--left heading--bigger">
                                5G-internet
                            </h3>
                            <p className="post-heading">
                                Til en knivskarp pris
                            </p>
                            <p className="pre-products-details">
                                Fri data
                            </p>
                            <div className="product-details">
                                <div className="price-details">
                                    <p className="price-container">
                                        <span className="price">
                                            {formatAmount(mbb_price, false)}<span className="comma-dash">,-</span>
                                        </span>
                                        <span className="md">/md.</span>
                                    </p>
                                    <p className="time">{mbb_time_text}</p>
                                    <p className="min-price">Mindstepris {formatAmount(mbb_min_6)}</p>
                                </div>
                                <ul className="product-list-usp">
                                    <li className="product-list-usp-item">
                                        <Icon component={IconTrophy}/>
                                        <span className="text">DK&rsquo;s bedste 5G-dækning</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconGears}/>
                                        <span className="text">Nem installation</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconCalendarCheck}/>
                                        <span className="text">Kom hurtigt online</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconSpeedometerHigh}/>
                                        <span className="text">Lynhurtigt internet</span>
                                    </li>
                                </ul>
                            </div>
                            <Link to={Routing.Broadband.TDC5G} className="button button--montserrat rounded red products-button-5g">
                                Læs mere
                            </Link>
                        </div>
                    </div>
                </li>
                <li className="product fiber alt">
                    <div className="image"></div>
                    <div className="product-box">
                        <div className="product-text">
                            <h3 className="heading heading--montserrat heading--left heading--bigger">
                                Hos Hiper får&nbsp;du&nbsp;Fiber
                            </h3>
                            <p className="post-heading">
                                Lige nu kan du f.eks. få
                            </p>
                            <p className="pre-products-details">
                                1000 Mbit fra
                            </p>
                            <div className="product-details">
                                <div className="price-details">
                                    <p className="price-container">
                                        <span className="price">
                                            {formatAmount(fiber_price, false)}<span className="comma-dash">,-</span>
                                        </span>
                                        <span className="md">/md.</span>
                                    </p>
                                    <p className="time">{fiber_time_text}</p>
                                    <p className="min-price">Mindstepris fra {formatAmount(fiber_min_6)}</p>
                                </div>
                                <ul className="product-list-usp">
                                    <li className="product-list-usp-item">
                                        <Icon component={IconServiceStatus}/>
                                        <span className="text">Mest stabile internet</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconSpeedometerHigh}/>
                                        <span className="text">Hurtigste hastighed</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconPing}/>
                                        <span className="text">Laveste ping</span>
                                    </li>
                                    <li className="product-list-usp-item">
                                        <Icon component={IconWifi}/>
                                        <span className="text">Mulighed for mesh</span>
                                    </li>
                                </ul>
                            </div>
                            <Link to={Routing.Broadband.Fiber} className="button button--montserrat rounded red products-button-fiber">
                                Læs mere
                            </Link>
                        </div>
                    </div>
                </li>
            </ul>

            <div className="content content--wide">
                <p className="conditions">
                    Inkl. gratis oprettelse og lånerouter.
                    Min. pris i 6 mdr. fra {formatAmount(fiber_min_6, false)} kr.
                    Pris efter {fiber_time} mdr. fra {formatAmount(fiber_price_default, false)} kr./md.
                    Tilbuddet gælder kun fiber på udvalgte adresser.
                    5G-internet hastighed er baseret på udendørs dækning og kan påvirkes af terræn og bebyggelse.
                </p>
            </div>
        </section>
    )
}
